<mat-icon style="float: right"><span (click)="clear()">clear</span></mat-icon>
<div>
  <form [formGroup]="otpForm">
    <div class="accordion-class">
      <h6>Verify OTP</h6>
      <mat-divider></mat-divider>
    </div>
    <div class="login">
      <p>Verify Your {{ data.dataKey.displayText }}</p>
      <h5>{{ data.dataKey.email }}</h5>
    </div>
    <div class="group otp-field">
      <ng-otp-input
        #ngOtpInput
        [config]="{ length: 4 }"
        (onInputChange)="onOtpChange($event)"
      ></ng-otp-input>
      <p *ngIf="verificationCode">Code: {{ Response?.code }}</p>
    </div>
    <a
      class="resent-btn btn"
      style="text-decoration-line: underline; color: #f29652; float: right"
      (click)="resendOTP()"
      >Resend otp</a
    >

    <a class="resent-btn"></a>
    <div *ngIf="otpWrongErrorMsg" class="otpMsg">
      Please enter the correct otp
    </div>
  </form>
</div>
